import InfoPersoStep1FormComponent from '../../components/info-perso/InfoPersoStep1FormComponent';


export default function InfoPersoStep1Bloc() {

      return (
        <div className="">
          <div className="">
            {/* <h2 className="card-title bleu">Votre identité :</h2>
            <p className="text mt-sm">Ces informations nous ont été transmises par votre service des ressources humaines.</p>
            <p className="text mb-sm">Nous vous invitons à leur communiquer toute modification éventuelle avant de commencer votre adhésion.</p> */}
            <InfoPersoStep1FormComponent/>  
          </div>
        </div>
      )
}